<template v-if="isLoaded">
  <SummerPeriodsEditor
    v-if="item.key === 'summerperiodsform'"
    :model="props.model"
    :metadata="form.metadata"
    @add="addNewPeriod"
    @remove="removePeriod2"
    @labelChange="onLabelChange"
    @back="back"
    @removeField="remove"
    @saveItem="saveItem"
  ></SummerPeriodsEditor>
  <div v-else-if="item.type === 'group'">
    <p class="mb-4">Dina förändringar sparas automatiskt.</p>
    <form class="grid grid-cols-4 gap-4" @submit.prevent="onSubmit">
      <InputText
        keyId="0"
        :placeholder="item.label"
        label="Rubrik för checkboxgrupp"
        :model="item.label"
        type="text"
        @change="onLabelChange"
        class="col-span-full"
      ></InputText>
      <div
        class="flex col-span-full gap-4 items-center"
        v-for="(prop, i) in item.data.keys"
        :key="i"
      >
        <BaseInput
          v-model="prop.label"
          :label="`checkbox ${i + 1}`"
          placeholder="Ange texten för checkboxen"
        />
        <i
          @click="removeOption(prop)"
          title="Ta bort"
          class="fas fa-trash-alt text-red-2 hover:text-red-2 text-2xl cursor-pointer"
        ></i>
      </div>
    </form>
    <div class="flex gap-4 mt-4">
      <RegularButton
        @click="addOption"
        style-type="primary"
        text="Lägg till val"
      />
      <RegularButton @click="remove" style-type="cancel" text="Ta bort grupp" />
      <RegularButton @click="back" style-type="success" text="Spara" />
      <RegularButton @click="back" text="Tillbaka" />
    </div>
  </div>
  <RadioGroupEditor
    v-else-if="item.type === 'radioGroup'"
    :model="props.model"
    :metadata="form.metadata"
    @add="addNewRadio"
    @remove="removeRadio"
    @labelChange="onLabelChange"
    @back="back"
    @removeField="remove"
    @changeRadioLabel="changeRadioLabel"
    @toggleRadioRequired="onToggleRadioRequired"
  ></RadioGroupEditor>
  <div v-else-if="item.type === 'textWithHelpLink'">
    <p class="mb-4">Dina förändringar sparas automatiskt.</p>
    <form
      action=""
      class="grid grid-cols-2 text-sm font-regular gap-4"
      @submit.prevent="onSubmit"
    >
      <div>
        <label
          class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
        >
          Label
        </label>
        <input
          type="text"
          class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          placeholder=""
          v-model="item.label"
        />
      </div>
      <div v-if="item.key !== 'form_file'">
        <label
          class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
        >
          Länk
        </label>
        <input
          type="text"
          class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          placeholder=""
          v-model="item.placeholder"
        />
      </div>
      <div class="flex col-span-full gap-4">
        <RegularButton
          @click="remove"
          style-type="cancel"
          text="Ta bort fält"
        />
        <RegularButton @click="back" style-type="success" text="Spara" />
        <RegularButton @click="back" text="Tillbaka" />
      </div>
    </form>
  </div>
  <div v-else>
    <p class="mb-4">Dina förändringar sparas automatiskt.</p>
    <form
      action=""
      class="grid grid-cols-2 text-sm font-regular gap-4"
      @submit.prevent="onSubmit"
    >
      <div>
        <label
          class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
        >
          Label
        </label>
        <input
          type="text"
          class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          placeholder=""
          v-model="item.label"
        />
      </div>
      <div v-if="item.key !== 'form_file'">
        <label
          class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
        >
          Placeholder
        </label>
        <input
          type="text"
          class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          placeholder=""
          v-model="item.placeholder"
        />
      </div>
      <div
        v-if="item.key === 'form_file'"
        class="text-darkGray-1 mb-1 flex items-center gap-2 col-span-full"
      >
        <label class="text-darkGray-1 mb-1 flex items-center gap-2">
          <input type="checkbox" v-model="fileUploadIsRequired" />
          Obligatorisk
        </label>
      </div>

      <div v-if="item.key === 'form_ssn'" class="flex flex-col col-span-full">
        <label class="text-darkGray-1 mb-1 flex items-center gap-2">
          <input type="checkbox" v-model="ssnOnlyAllowedYears" />
          Godkänn endast personer som är födda specifika år
        </label>

        <div class="flex flex-col gap-2" v-if="ssnOnlyAllowedYears">
          <button
            @click="addYear"
            class="text-blue-2 hover:text-blue-1 text-left"
          >
            Lägg till år
          </button>
          <div
            class="flex items-center gap-2"
            v-for="(year, i) in ssnAllowedYears"
            :key="i"
          >
            <input
              type="number"
              class="appearance-none border-gray-2 block w-28 bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded-md py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              placeholder="Ange år"
              v-model="ssnAllowedYears[i]"
            />
            <button
              @click="removeYear(i)"
              class="bg-gradient-to-t from-red-700 to-red-2 hover:from-red-600 hover:to-red-3 text-sm rounded-md text-white px-3 py-3"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="item.key === 'form_ssn'" class="flex flex-col col-span-full">
        <label class="text-darkGray-1 mb-1 flex items-center gap-2">
          <input type="checkbox" v-model="ssnAgeBeforeAndAfterPeriod.value" /> 
          Godkänn endast personer som har viss ålder under viss period
        </label>

        <div
          class="flex flex-col gap-2"
          v-if="ssnAgeBeforeAndAfterPeriod.value"
        >
          <button
            @click="addPeriod"
            class="text-blue-2 hover:text-blue-1 text-left"
          >
            Lägg till period
          </button>
          <SsnAgeInPeriods
            v-for="(period, i) in ssnAgeBeforeAndAfterPeriod.periods"
            :period="period"
            :key="period.key"
            :index="i"
            @remove-period="removePeriod(i)"
            @save-period="savePeriod"
            class="flex flex-col gap-2 p-4 text-darkGray-1 bg-white ring-1 ring-orange-2 w-full rounded-md max-w-[500px]"
          />
        </div>
      </div>
      <div class="flex col-span-full gap-4">
        <RegularButton
          @click="remove"
          style-type="cancel"
          text="Ta bort fält"
        />
        <RegularButton @click="back" style-type="success" text="Spara" />
        <RegularButton @click="back" text="Tillbaka" />
      </div>
    </form>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref, onMounted, watch } from "vue";
import { defineEmits } from "@vue/runtime-core";
import InputText from "@/features/shared/components/form/InputText.vue";
import SummerPeriodsEditor from "@/features/shared/components/form/editor/SummerPeriodsEditor.vue";
import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import { FormBuilder2 } from "@/models/FormBuilder2";
import { ToastNotification } from "@/models/ToastNotification";
import RegularButton from "../ui/RegularButton.vue";
import BaseInput from "./BaseInput.vue";
import { DynamicProperty } from "../../models/dtos";
import SsnAgeInPeriods from "./validators/SsnAgeInPeriods.vue";
import RadioGroupEditor from "./editor/RadioGroupEditor.vue";

const emit = defineEmits(["change", "remove", "isEdit", "customChange"]);

const store = useStore();
const form = ref(store.getters.form as FormBuilder2);

const props = defineProps<{
  model: dtos.DynamicProperty;
  index?: number;
}>();
// const old = JSON.parse(JSON.stringify(props.model));
const item = ref(props.model as dtos.DynamicProperty);
const isLoaded = ref(false);

const saveItem = (item: DynamicProperty) => {
  // form.value.setPeriodItem(item);
};
// function save() {
//   const x = {
//     value: old,
//     index: props.index,
//   };
//   emit("change", x);
// }

const back = () => {
  emit("isEdit", false);
};

function remove() {
  store.dispatch(
    "addNotification",
    new ToastNotification("success", "Fältet har tagits bort")
  );
  const form = store.getters.form as FormBuilder2;
  form.removeByProperty(item.value);
  emit("isEdit", false);
  // emit("remove", item.value);s
}

function removeOption(optionKey: DynamicProperty) {
  form.value.removeOptionFromGroup(item.value.data, optionKey, item.value.key);
}
function removePeriod2(item: DynamicProperty) {
  form.value.removePeriodFromGroup(item);
}
function addNewPeriod(key: string, item: DynamicProperty) {
  form.value.addPeriodToGroup(key, item);
}

function addNewRadio(key: string, item: DynamicProperty) {
  form.value.addRadioToGroup(key, item);
}
function changeRadioLabel(key: string, newLabel: string) {
  const form = store.getters.form as FormBuilder2;

  form.changeRadioButtonLabel(key, newLabel);
}

function removeRadio(item: DynamicProperty) {
  form.value.removeRadioFromGroup(item);
}

function addOption() {
  form.value.addOptionToGroup(item.value.data, item.value.key);
}

function onLabelChange(event: any) {
  item.value.data.label = event;
  item.value.label = event;
  item.value.placeholder = event;

  form.value.setCheckboxGroupLabel(item.value, event);
  emit("customChange", item.value);
}

const ssnOnlyAllowedYears = ref(false);

interface SsnPeriod {
  key: string;
  periodStart: string;
  periodEnd: string;
  ageLow: number;
  ageHigh: number;
}

interface SsnAgeBeforeAndAfterPeriod {
  value: boolean;
  periods: SsnPeriod[];
}
const ssnAgeBeforeAndAfterPeriod = ref<SsnAgeBeforeAndAfterPeriod>({
  value: false,
  periods: [],
}); 

const addPeriod = () => {
  ssnAgeBeforeAndAfterPeriod.value.periods.push({
    key: crypto.randomUUID(),
    periodStart: "",
    periodEnd: "",
    ageLow: 0,
    ageHigh: 0,
  });
};

const removePeriod = (index: number) => {
  ssnAgeBeforeAndAfterPeriod.value.periods.splice(index, 1);
  updateValidationWithPeriods();
};

const savePeriod = (period: SsnPeriod, index: number) => {
  ssnAgeBeforeAndAfterPeriod.value.periods[index] = period;
  updateValidationWithPeriods();
};
const initAllowedAgeInPeriod = () => {
  const validator = item.value.validators.find(
    (validator) => validator.name === "allowedAgeInPeriod"
  );
  if (validator) {
    item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    
    validator.data.forEach( ((element :any) => {
      ssnAgeBeforeAndAfterPeriod.value.periods.push({
      key: crypto.randomUUID(),
      periodStart: element.periodStart,
      periodEnd: element.periodEnd,
      ageLow: element.minAge,
      ageHigh: element.maxAge,
  });
    }));
  }
    if (ssnAgeBeforeAndAfterPeriod.value.periods.length > 0) ssnAgeBeforeAndAfterPeriod.value.value = true;
  
};
const updateValidationWithPeriods = () => {
  const validator = item.value.validators.find(
    (validator) => validator.name === "allowedAgeInPeriod"
  );
  if (validator) {
    item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    
    
  
    if (ssnAgeBeforeAndAfterPeriod.value.periods.length > 0) ssnAgeBeforeAndAfterPeriod.value.value = true;
    
  }

  if (ssnAgeBeforeAndAfterPeriod.value.periods.length === 0) {
    //return;
  }

  const newValidation = new dtos.PropertyValidator(
    "allowedAgeInPeriod",
    ssnAgeBeforeAndAfterPeriod.value.periods.map((period) => {
      return {
        periodStart: period.periodStart,
        periodEnd: period.periodEnd,
        minAge: period.ageLow,
        maxAge: period.ageHigh,
      };
    })
  );

  item.value.validators.push(newValidation);
};

const ssnAllowedYears = ref([]);

function addYear() {
  ssnAllowedYears.value.push("");
}

function removeYear(index: number) {
  ssnAllowedYears.value.splice(index, 1);
}

watch(
  () => ssnAllowedYears,
  (newValue, oldValue) => {
    const validator = item.value.validators.find(
      (validator) => validator.name === "allowedYears"
    );

    if (validator) {
      item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    }

    const minYear = new dtos.PropertyValidator(
      "allowedYears",
      ssnAllowedYears.value.join(",")
    );

    item.value.validators.push(minYear);
  },
  { deep: true }
);

watch(
  () => ssnOnlyAllowedYears.value,
  (newValue, oldValue) => {
    if (!newValue) {
      const validator = item.value.validators.find(
        (validator) => validator.name === "allowedYears"
      );

      if (validator) {
        item.value.validators.splice(
          item.value.validators.indexOf(validator),
          1
        );
      }
    }
  }
);

// file upload
const fileUploadIsRequired = ref(false);

onMounted(() => {
  const allowedYears = item.value.validators.find(
    (validator) => validator.name === "allowedYears"
  )?.data;

  if (allowedYears) {
    ssnOnlyAllowedYears.value = true;
    ssnAllowedYears.value = allowedYears.split(",");
  }

  const fileIsRequired = item.value.validators.find(
    (validator) => validator.name === "fileRequired"
  )?.data;

  if (fileIsRequired) {
    fileUploadIsRequired.value = true;
  }
initAllowedAgeInPeriod();
  isLoaded.value = true;
});

watch(
  () => fileUploadIsRequired.value,
  (newValue, oldValue) => {
    const validator = item.value.validators.find(
      (validator) => validator.name === "fileRequired"
    );

    if (validator) {
      item.value.validators.splice(item.value.validators.indexOf(validator), 1);
    }

    const fileRequired = new dtos.PropertyValidator(
      "fileRequired",
      fileUploadIsRequired.value
    );

    item.value.validators.push(fileRequired);
  }
);

watch(
  () => ssnAgeBeforeAndAfterPeriod.value.value,
  (newValue) => {
    if (!newValue) {
      ssnAgeBeforeAndAfterPeriod.value.periods = [];
      updateValidationWithPeriods();
    }
  }
);

const onToggleRadioRequired = (value: boolean) => {
  store.dispatch("formbuilder/toggleIsRequired", {
    key: item.value.key,
    value: value,
  });
};
</script>
